module.exports = __webpack_public_path__ + "static/media/Lockton_Marine_P&I_west.06c47df7.pdf";